import React, { useCallback, useId, useMemo, useState } from "react";
import classNames from "classnames";
import Select, { createFilter } from "react-select";
import CheckSolid from "../../icons/check-solid-green.svg";
import NotValid from "../../icons/not-valid.svg";
import { useAllProducts } from "../../query/use-all-products";
import { useProduct } from "../../query/use-product";

const AutocompleteSelect = ({
  label,
  name,
  options,
  onBlur = () => 0,
  className,
  rules,
  search = true,
  labelManagerLabels,
  handleOptionSelection,
  isCompatibleModels,
  accSku,
  ...other
}) => {
  const [focusedCompatible, setFocusCompatible] = useState(false);
  const [productEnabled, setProductEnabled] = useState(false);
  const { data } = useAllProducts(focusedCompatible);
  const [showOptions, setShowOptions] = useState(false);
  const productOptions = isCompatibleModels
    ? options
    : !isCompatibleModels && data?.length > 0
    ? data
    : [];
  const uniqueId = useId();
  const fieldId = `field${uniqueId}`;
  const [focused, setFocused] = useState(false);
  const [value, setValue] = useState();
  const selectedOption = productOptions.find((option) => option.value === value);

  const { data: dataProduct, isLoading } = useProduct(productEnabled, selectedOption?.code);

  const isDataProduct =
    !!dataProduct?.GetProductDetailsResult.accessoriesByLine
      .split(",")
      .find((item) => item.trim() === accSku) ||
    !!dataProduct?.GetProductDetailsResult.accessoriesBySku
      .split(",")
      .find((item) => item.trim() === accSku);

  const handleInputChange = useCallback((typedOption) => {
    setShowOptions(typedOption.length > 2);
  }, []);

  const checkValid = useMemo(() => {
    return !!(
      ((!isCompatibleModels && !!isDataProduct && selectedOption) ||
        (isCompatibleModels && selectedOption)) &&
      !isLoading
    );
  }, [isCompatibleModels, isDataProduct, selectedOption, isLoading]);

  const checkNotValid = useMemo(() => {
    return !!(!isDataProduct && selectedOption && !isCompatibleModels && !isLoading);
  }, [isCompatibleModels, isDataProduct, selectedOption, isLoading]);

  return (
    <>
      <div
        className={classNames("form-field  form-field--acc", className, {
          "form-field--focused": focused,
          "form-field--filled": !!value,
        })}
        {...other}
      >
        <label className="form-field__label" htmlFor={fieldId} id={`${fieldId}-label`}>
          {labelManagerLabels.insertSkuProduct}
        </label>
        <div className="form-field__wrapper">
          <Select
            id={fieldId}
            name={name}
            className="form-field__select-container"
            classNamePrefix="form-field-select"
            closeMenuOnSelect={true}
            isSearchable={search}
            placeholder=""
            filterOption={createFilter({ matchFrom: "start" })}
            value={selectedOption ? selectedOption : labelManagerLabels.insertSkuProduct}
            onFocus={() => {
              if (!isCompatibleModels) {
                setFocusCompatible(true);
              }
              setFocused(true);
            }}
            onBlur={(e) => {
              onBlur(e);
              setFocused(false);
            }}
            onChange={(option, actionType) => {
              if (actionType.action === "clear") {
                setValue(null);
                if (isCompatibleModels) {
                  handleOptionSelection(null);
                }
                return;
              }
              if (!isCompatibleModels) {
                setProductEnabled(true);
              }
              setValue(option.value);
              if (isCompatibleModels) {
                handleOptionSelection(option.value);
              }
            }}
            options={showOptions ? productOptions : []}
            components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }}
            onInputChange={handleInputChange}
            isClearable={true}
            noOptionsMessage={() => labelManagerLabels.noOptionsSelect}
          />
        </div>
      </div>
      {isLoading && (
        <div className="products__loader">
          <span className="dual-ring-loader dual-ring-loader--acc"></span>
        </div>
      )}
      {!!checkValid && (
        <div className="autocomplete-select" role="alert">
          <div className="autocomplete-select__image-wrapper">
            <CheckSolid />
          </div>
          <div className="autocomplete-select__message">
            {labelManagerLabels.compatibleAppliance}
          </div>
        </div>
      )}
      {!!checkNotValid && (
        <div className="autocomplete-select autocomplete-select--not-valid" role="alert">
          <div className="autocomplete-select__image-wrapper">
            <NotValid />
          </div>
          <div className="autocomplete-select__message">
            {labelManagerLabels.incompatibleAppliance}
          </div>
        </div>
      )}
    </>
  );
};

export default AutocompleteSelect;
